import React from 'react';
import { Switch, Route } from 'react-router-dom';
import {
  DEFAULT,
  LOGIN,
  LOGINMOTOR,
  RECOVER_PASSWORD,
  REGISTER,
} from '@shared/helpers/routes';
import LoginMotorstatic from '@shared/pages/LoginMotorstatic/LoginMotorstatic';
import NotFoundPage from '@shared/pages/NotFoundPage';
import Login from '@shared/pages/Login';
import Register from '@shared/pages/Register';
import RecoverPassword from '@shared/pages/RecoverPassword';

export default ({ pageConfiguration }) => {
  return (
    <Switch>
      <Route exact path={LOGIN} render={props => <Login {...props} />} />
      <Route
        path={LOGINMOTOR}
        render={props => <LoginMotorstatic {...props} />}
      />
      {pageConfiguration?.site_functions?.userRegister && (
        <Route
          exact
          path={REGISTER}
          render={props => <Register {...props} />}
        />
      )}
      <Route
        path={RECOVER_PASSWORD}
        render={props => <RecoverPassword {...props} />}
      />
      <Route path={DEFAULT}>
        <NotFoundPage />
      </Route>
    </Switch>
  );
};
